import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "evses" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 当天交流放电电量")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("(单位：Wh) ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 当天交流放电电量")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("(单位：Wh) ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 当天交流充电电量")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("(单位：Wh) ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 今日光伏发电量")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("(单位：Wh) ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 今日馈网电量")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("(单位：Wh) ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 今日光伏馈网电量")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode("(单位：Wh) ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 今日自足率")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode("(单位：%) ")
const _hoisted_26 = { class: "emq-table-footer" }

import { throttle } from 'lodash'
import { delEvse, banEvse, listEvse, DeleteEssDevice } from '@/api/evses'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import {
  ArrowDown,
  ArrowUp,
  Refresh,
  RefreshLeft,
  Search,
  Plus,
  Download,
} from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import SelectOperator from '@/components/SelectOperator.vue'
import SelectStation from '@/components/SelectStation.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { GetEssDeviceList } from '@/api/evses'

import { defineComponent, ref, computed, defineProps, reactive, onMounted } from 'vue'
import SelectStationNature from '@/components/SelectStationNature.vue'
import EssDeviceDrawer from './components/EssDeviceDrawer.vue'
const __default__ = defineComponent({
  name: 'EssDevice',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  opeartorID: {
    type: String,
    default: '',
  },
  stationID: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

const EvseDrawerRef = ref()

const { t } = useI18nTl('Evses')

const showDialog = ref(false)
const editEditFlag = ref(false)
const showDialogEssDevice = ref({})
const showMoreQuery = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('evses-detail')


const isStation = computed(function () {
  return props.stationID != '' && props.stationID != '0'
})
const addEssDevice = () => {
  editEditFlag.value = false
  showDialogEssDevice.value = {}
  showDialog.value = true
  EvseDrawerRef.value?.clearValidate()
}
const editEssDevice = (row: any) => {
  showDialogEssDevice.value = row
  editEditFlag.value = true
  showDialog.value = true
}

const deleteEssDevice = async (row: any) => {
  await ElMessageBox.confirm(t('Evses.deleteEssDeviceConfirm'), {
    confirmButtonText: t('Base.confirm'),
    cancelButtonText: t('Base.cancel'),
    confirmButtonClass: 'confirm-danger',
    callback: async (val: string) => {
      if (val == 'confirm') {
        try {
          await DeleteEssDevice({ id: row.id })
          ElMessage.success(t(`Base.opSuccess`))
          loadEssDevice()
        } catch (error) {
          console.error('del error:', error)
        }
      }
    },
    type: 'warning',
  })
}

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadEssDevice({ page: 1 })
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { operatorId, stationId, stationNature } = params

  newParams = {
    operatorId: operatorId || '0',
    stationId: stationId || '0',
    stationNature: stationNature || '0',
  }
  return newParams
}
const loadEssDevice = async (_params = {}) => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
  }

  if (!sendParams?.stationId || sendParams.stationId == '') {
    if (props.stationID != '') {
      sendParams.stationId = props.stationID
    } else {
      sendParams.stationId = '0'
    }
  }
  try {
    const { list = [], pageReply = {} } = await GetEssDeviceList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttle(loadEssDevice)
onMounted(() => {
  loadEssDevice()
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isStation))
      ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          class: "search-wrapper",
          onKeyup: _withKeys(handleSearch, ["enter"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(SelectOperator, {
                      modelValue: fuzzyParams.value.operatorId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.operatorId) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(SelectStation, {
                      modelValue: fuzzyParams.value.stationId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.stationId) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(SelectStationNature, {
                      modelValue: fuzzyParams.value.stationNature,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.stationNature) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      plain: "",
                      icon: _unref(Search),
                      onClick: handleSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_button, {
                      icon: _unref(RefreshLeft),
                      onClick: handleReset
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_tooltip, {
                      content: !showMoreQuery.value ? _ctx.$t('Base.showMore') : _ctx.$t('Base.lessMore'),
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "icon-button",
                          plain: "",
                          icon: showMoreQuery.value ? _unref(ArrowUp) : _unref(ArrowDown),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (showMoreQuery.value = !showMoreQuery.value))
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["content"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onKeyup"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (addEssDevice()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'evseUpsert']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "evseSn"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "alias",
            "min-width": "80",
            label: '设备别名',
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "sn",
            "min-width": "80",
            label: '设备序列号',
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "model",
            "min-width": "80",
            label: '设备型号',
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "todaysDischargeEnergy",
            "min-width": "80",
            align: "center"
          }, {
            header: _withCtx(() => [
              _hoisted_5,
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "todaysDischargeEnergy",
            "min-width": "80",
            align: "center"
          }, {
            header: _withCtx(() => [
              _hoisted_8,
              _hoisted_9,
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "todaysChargeEnergy",
            "min-width": "80",
            align: "center"
          }, {
            header: _withCtx(() => [
              _hoisted_11,
              _hoisted_12,
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "todaysEnergyGenPV",
            "min-width": "80",
            align: "center"
          }, {
            header: _withCtx(() => [
              _hoisted_14,
              _hoisted_15,
              _hoisted_16
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "todaysFeedbackGrid",
            "min-width": "80",
            align: "center"
          }, {
            header: _withCtx(() => [
              _hoisted_17,
              _hoisted_18,
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "todaysFeedbackGridPV",
            "min-width": "80",
            align: "center"
          }, {
            header: _withCtx(() => [
              _hoisted_20,
              _hoisted_21,
              _hoisted_22
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "todaysSufficiencyRate",
            "min-width": "80",
            label: '',
            align: "center"
          }, {
            header: _withCtx(() => [
              _hoisted_23,
              _hoisted_24,
              _hoisted_25
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            className: "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (editEssDevice(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (deleteEssDevice(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.delete')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[5] || (_cache[5] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          pageSizeOpt: [10, 20, 50, 100],
          onLoadPage: loadEssDevice
        }, null, 8, ["metaData"])
      ])
    ]),
    _createVNode(EssDeviceDrawer, {
      ref_key: "EvseDrawerRef",
      ref: EvseDrawerRef,
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showDialog).value = $event)),
      opeartorID: props.opeartorID,
      stationID: props.stationID,
      isEdit: editEditFlag.value,
      evseInfo: showDialogEssDevice.value,
      onSubmitted: loadEssDevice
    }, null, 8, ["modelValue", "opeartorID", "stationID", "isEdit", "evseInfo"])
  ]))
}
}

})